var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',_vm._g(_vm._b({attrs:{"size":_vm.size,"type":"primary"}},'van-button',_vm.customizedAttrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }